// ── Construction Market brand palette — single source of truth ──────────────────────
// Mirrors the CSS variables in index.css (:root). Tailwind's built-in `orange` scale is
// used across the UI for the accent and already matches these values:
//   orange-600 ≈ #EA580C (orange) · orange-400 ≈ #FB923C (orange-light) · orange-50 ≈ #FFF7ED (wash)
// so the accent sweep (purple → orange) stays on-brand without custom Tailwind config.
export const BRAND = {
  ink: '#0F1520',          // primary dark: headers, text, dark surfaces
  slate: '#334155',        // secondary structure
  muted: '#64748B',        // muted text
  line: '#E2E8F0',         // borders
  cloud: '#F8FAFC',        // app background / subtle surfaces
  white: '#FFFFFF',        // cards, base
  orange: '#EA580C',       // PRIMARY ACCENT: primary buttons, CTAs, active states, brand
  orangeLight: '#FB923C',  // hover
  orangeWash: '#FFF7ED',   // subtle highlight bg
  success: '#16A34A',
  alert: '#DC2626',
};
export default BRAND;
